import React, { useEffect } from 'react'
import Drawer from '../../../components/common/Drawer'
import { useForm } from 'react-hook-form'
import Input from '../../../components/form/input/InputField'
import Label from '../../../components/form/Label'
import toast from 'react-hot-toast'
import { api } from '../../../configs/api'
import { useBusiness } from '../../../context/BusinessContext'
import { useAuth } from '../../../context/AuthContext'

const PipelineCreate = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
    const { business } = useBusiness()
    const { unity } = useAuth()
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)

    const createPipelineContext = (values: { name: string; value: string; unityID: number; pipelineID: string }) => {
        const newPipeline = {
            id: values.pipelineID,
            value: values.value,
            label: values.name,
            steps: []
        }
        business.pipelines.push(newPipeline)
    }

    const handleSave = async (values: any) => {
        if (!values.name || !unity) {
            toast.error('Preencha o nome do pipeline!')
            return
        }

        try {
            const response = await fetch(`${api}business/createPipeline`, {
                method: 'POST',
                body: JSON.stringify({
                    ...values,
                    unityID: unity.unityID
                })
            })
            const result = await response.json()

            if (!result || !result.pipelineID) {
                toast.error('Não foi possível criar o pipeline!')
                return
            }

            values = {
                ...values,
                pipelineID: result.pipelineID,
                value: result.value
            }

            createPipelineContext(values)

            toast.success('Pipeline criado com sucesso!')
        } catch (error) {
            console.log(error)
        } finally {
            handleClose()
        }
    }

    useEffect(() => {
        form.setValue('name', '')
    }, [open])

    return (
        <Drawer
            open={open}
            handleClose={handleClose}
            title='Novo Pipeline'
            handleSave={() => formRef.current?.requestSubmit()}
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleSave)}>
                <div className='space-y-3'>
                    <div>
                        <Label required>Nome</Label>
                        <Input {...form.register('name', { required: true })} placeholder='Nome do pipeline' />
                    </div>
                </div>
            </form>
        </Drawer>
    )
}

export default PipelineCreate
